import type { ServiceOccupant } from 'restaurantAdmin/reservations/service/apiHelpers';

export const isOccupantActive = (
  occupant: Pick<ServiceOccupant, 'status'> | undefined | null,
): boolean => occupant?.status === 'active';
